<div *ngIf="!moduledisplay">
  <div class="d-flex flex-column flex-sm-row justify-content-between">
    <a routerLink="/user/userprofile" [queryParams]="{userid:this.tutor.uid}" class="d-flex flex-column flex-sm-row align-items-center text-reset">
      <img src="{{userimageurl}}" alt="Profile picture of {{fullname}}" class="tutor__img bg-gray-100 circle shadow-sm-darker object-cover object-center">
      <div class="mx-0 mx-sm-2 text-center text-sm-left">
        <span *ngIf="!tutor.isdisabled && showbuttons" class="tutor-status-indicator text-primary-darker mr-2" title="Enabled"></span>
        <span *ngIf="tutor.isdisabled && showbuttons" class="tutor-status-indicator text-warning mr-2" title="Disabled"></span>
        <span class="text-xs">{{fullname}} - {{email}}</span>  
      </div>
    </a>
    <div *ngIf="showbuttons" class="tutor-action-btn-wrap d-flex align-items-center justify-content-around justify-content-sm-end flex-wrap flex-shrink-0 mt-3 mt-sm-0">
      <button *ngIf="!confirmUserDelete" class="btn btn--danger tutor-action-btn" (click)="popconfirmdelete(1)">Remove</button>
      <button *ngIf="!tutor.isdisabled && !confirmUserDelete" class="btn btn--warning tutor-action-btn" (click)="manageuserclicked(email, modulemanager.DISABLE_USER )">Disable</button>
      <button *ngIf="tutor.isdisabled && !confirmUserDelete" class="btn tutor-action-btn" (click)="manageuserclicked(email, modulemanager.ENABLE_USER )">Enable</button>
    </div>
  </div>
  <div>
    <p *ngIf="confirmUserDelete" class="alert mt-3 text-center deleteConfirmText">Are you sure you want to remove this user?</p>
    <div class="tutor-action-btn-wrap d-flex justify-content-around flex-wrap mt-1">
      <button *ngIf="confirmUserDelete" (click)="manageuserclicked(email ,modulemanager.REMOVE_USER)" class="btn btn--danger tutor-action-btn">Yes</button>
      <button *ngIf="confirmUserDelete" (click)="popconfirmdelete(0)" class="btn tutor-action-btn">No</button>  
    </div>
  </div>
</div>

<div *ngIf="moduledisplay" class="tutor">
  <a routerLink="/user/userprofile" [queryParams]="{userid:this.tutor.uid}" class="d-block text-center text-body">
    <img src="{{userimageurl}}" alt="Profile picture of {{fullname}}" class="tutor__img bg-gray-100 circle shadow-sm-darker object-cover object-center">
    <div class="mt-2 text-xs">{{fullname}}</div>
  </a>
</div>
